import { gql } from '@apollo/client'

import { METADATA_NODE_FRAGMENT } from '../fragments'

const INGREDIENTS_QUERY = gql`
  query ingredients {
    ingredients {
      results {
        ...MetadataNodeFragment
        isWholeFood
        isVague

        componentIngredients {
          id
          type
        }

        replaces {
          ...MetadataNodeFragment
          replaceToken
        }

        replacedBy {
          ...MetadataNodeFragment
          replaceToken
        }

        children {
          ...MetadataNodeFragment
          isWholeFood
          isVague

          componentIngredients {
            id
            type
          }

          replaces {
            ...MetadataNodeFragment
            replaceToken
          }

          replacedBy {
            ...MetadataNodeFragment
            replaceToken
          }

          children {
            ...MetadataNodeFragment
            isWholeFood
            isVague

            componentIngredients {
              id
              type
            }

            replaces {
              ...MetadataNodeFragment
              replaceToken
            }

            replacedBy {
              ...MetadataNodeFragment
              replaceToken
            }
          }
        }
      }
    }
  }
  ${METADATA_NODE_FRAGMENT}
`

export default INGREDIENTS_QUERY
